export default __webpack_public_path__ + "static/media/Globe.2a8d5cf9.svg";